import React, {useEffect, useState} from "react";
import axios from "axios";
import AssignWorkSpace from "./AssignWorkSpace";
import ErrorsInfo from "../../../Componnets/EsmManagement/controlPanelErrorsInfo/ErrorsInfo";
import http from "../../../../services/api/utilities/http";

export default function Verified(props) {
  const [status, setStatus] = useState(props.value.load_data_status)

  const handleRemove = (e) => {
    e.stopPropagation();
    props.remove();
  }

  useEffect(()=>{
    setStatus(props.value.load_data_status)
  },[props.value.load_data_status])

  const startLoad = () => {
    setStatus('In progress')
    http.put('data_connector/data_pool_load/' + props.value.id + '/',
      {
        "start_now": true,
        "datetime": null
      })
      .then(res => {
        console.log('close', res)
      })
      .catch(err => {
        setStatus('HAS EXCEPTION')
      })
  }

  return (
    status.toUpperCase() === 'FINISHED' ?
      <div style={{height: 150, cursor: "pointer"}} className="verified mt-24 mr-3" onClick={props.show}>
        {/*<Link to={{pathname: '/process-map'}}>*/}
          <p className="fw500 f14 dark-gary-2">{props.value.name}</p>
          <p className="fw300 f12 gray">status :
            <span className="fw600 f12 green-text">Loaded</span>
          </p>
          {
            localStorage.getItem("role") === "admin" && <AssignWorkSpace datapoolId={props.value.id} cacheStatus={props.value?.cached_process_explorer} oneCacheInProgress={props.oneCacheInProgress} />
          }
        {/*</Link>*/}
        <div className="d-flex control">
          <svg className={localStorage.getItem("role") !== "admin" && "disable"} style={{marginRight: 10, opacity: 0.25, pointerEvents: "none"}} width="15" height="15" viewBox="0 0 15 15" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.6615 0.859337H4.16883C2.11883 0.859337 0.833496 2.31067 0.833496 4.36534V9.908C0.833496 11.9627 2.11283 13.414 4.16883 13.414H10.0515C12.1082 13.414 13.3875 11.9627 13.3875 9.908V7.22267"
              stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M4.88517 6.2806L9.86717 1.2986C10.4878 0.678603 11.4938 0.678603 12.1145 1.2986L12.9258 2.10994C13.5465 2.7306 13.5465 3.73727 12.9258 4.35727L7.91984 9.36327C7.6485 9.6346 7.2805 9.78727 6.8965 9.78727H4.39917L4.46184 7.26727C4.47117 6.8966 4.6225 6.54327 4.88517 6.2806Z"
                  stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9.11011 2.06834L12.1541 5.11234" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
          </svg>
          <svg className={localStorage.getItem("role") !== "admin" && "disable"} onClick={handleRemove} width="14" height="14" viewBox="0 0 14 14" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.8833 5.31213C11.8833 5.31213 11.5213 9.80213 11.3113 11.6935C11.2113 12.5968 10.6533 13.1261 9.73927 13.1428C7.99994 13.1741 6.25861 13.1761 4.51994 13.1395C3.64061 13.1215 3.09194 12.5855 2.99394 11.6981C2.78261 9.79013 2.42261 5.31213 2.42261 5.31213"
              stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12.8056 3.1598H1.50024" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path
              d="M10.6271 3.1598C10.1038 3.1598 9.65313 2.7898 9.55047 2.27713L9.38847 1.46647C9.28847 1.09247 8.9498 0.833801 8.5638 0.833801H5.7418C5.3558 0.833801 5.01713 1.09247 4.91713 1.46647L4.75513 2.27713C4.65247 2.7898 4.2018 3.1598 3.67847 3.1598"
              stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <svg id="right" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.08337 4.16666L12.9167 9.99999L7.08337 15.8333" stroke="#0A195C" strokeWidth="1.5"
                strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      :
      <div style={{height: 150}} className="verified mt-24 mr-3">
        <p className="fw500 f14 dark-gary-2">{props.value.name}</p>
        <p className="fw300 f12 gray">status :
          {status === 'HAS EXCEPTION' ?
            <span className="fw600 f12 red">Error</span>
            :
            <span className="fw600 f12 main-purple">Verified (Not Loaded)</span>
          }
        </p>
        {

          (status === 'NOT STARTED' && props.value.scheduled_for) &&
          <>
            <p className="fw300 f12 dark-gary-2 mt-24">Scheduled for</p>
            <div className="d-flex justify-content-between">
              <p className="fw500 f12 dark-gary-2">{props.value.scheduled_for}</p>
              {/*<p className="fw500 f12 dark-gary-2">{2020/2/30  |  22:50}</p>*/}
              <p onClick={startLoad} style={{position: 'absolute', top: 119, right: 25}}
                 className="fw600 f12 main-purple pointer">Load Now</p>
            </div>
          </>
        }
        {
          (status === 'NOT STARTED' && !props.value.scheduled_for) &&
          <div className="d-flex" style={{marginTop: 39}}>
            <p onClick={startLoad} className="fw600 f12 main-purple pointer">Load Now</p>
            <p className="fw600 f12 main-purple mx-3"> | </p>
            <p className="fw600 f12 main-purple pointer">Schedule</p>
          </div>
        }
        {
          status === 'In progress'
          &&
          <>
            <div style={{marginTop: 29}} className="d-flex justify-content-between mb-1">
              <p className="fw300 f12 main-purple">Data Loading</p>
              <p className="fw300 f12 main-purple pointer">Cancel</p>
            </div>
            <div className="progress-grad">
              <div className={`progress-bar`} style={{width: '100%'}}></div>
            </div>
          </>
        }
        {
          status === 'HAS EXCEPTION'
          &&
          <>
            <div className={'mt-30'}>
              <ErrorsInfo errorTitle={'Verification Failed!'} errorDescription={props.value.exception_str} />
            </div>
            {/*<div className="d-flex justify-content-between">*/}
            {/*  <p className="fw500 f12 red">Details</p>*/}
            {/*</div>*/}
          </>
        }


        <div className="d-flex control">
          <svg className={localStorage.getItem("role") !== "admin" && "disable"} style={{marginRight: 10, opacity: 0.25, pointerEvents: "none"}} width="15" height="15" viewBox="0 0 15 15" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.6615 0.859337H4.16883C2.11883 0.859337 0.833496 2.31067 0.833496 4.36534V9.908C0.833496 11.9627 2.11283 13.414 4.16883 13.414H10.0515C12.1082 13.414 13.3875 11.9627 13.3875 9.908V7.22267"
              stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M4.88517 6.2806L9.86717 1.2986C10.4878 0.678603 11.4938 0.678603 12.1145 1.2986L12.9258 2.10994C13.5465 2.7306 13.5465 3.73727 12.9258 4.35727L7.91984 9.36327C7.6485 9.6346 7.2805 9.78727 6.8965 9.78727H4.39917L4.46184 7.26727C4.47117 6.8966 4.6225 6.54327 4.88517 6.2806Z"
                  stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9.11011 2.06834L12.1541 5.11234" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
          </svg>
          <svg  className={localStorage.getItem("role") !== "admin" && "disable"} onClick={handleRemove} width="14" height="14" viewBox="0 0 14 14" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.8833 5.31213C11.8833 5.31213 11.5213 9.80213 11.3113 11.6935C11.2113 12.5968 10.6533 13.1261 9.73927 13.1428C7.99994 13.1741 6.25861 13.1761 4.51994 13.1395C3.64061 13.1215 3.09194 12.5855 2.99394 11.6981C2.78261 9.79013 2.42261 5.31213 2.42261 5.31213"
              stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12.8056 3.1598H1.50024" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path
              d="M10.6271 3.1598C10.1038 3.1598 9.65313 2.7898 9.55047 2.27713L9.38847 1.46647C9.28847 1.09247 8.9498 0.833801 8.5638 0.833801H5.7418C5.3558 0.833801 5.01713 1.09247 4.91713 1.46647L4.75513 2.27713C4.65247 2.7898 4.2018 3.1598 3.67847 3.1598"
              stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <svg id="right" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.08337 4.16666L12.9167 9.99999L7.08337 15.8333" stroke="#0A195C" strokeWidth="1.5"
                strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
  )
}
